var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.logined)?_c('div',{staticClass:"main"},[_c('header',{staticClass:"header"},[_c('TumsHeader')],1),_c('div',{staticClass:"contents"},[_c('router-view')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }